export const ORDER_URL = `https://www.amazon.com/Shenanigans-Insiders-US-Ireland-Relationship-Uncertain/dp/0998749338/ref=sr_1_fkmrnull_1?keywords=shenanigans+vargo&qid=1551680899&s=gateway&sr=8-1-fkmrnull`

export const DONATE_URL = `https://www.us-irelandalliance.org/`
